import React from 'react';
import {MENUS} from '../../../../../../utils/query_utils';
import DatasetAttributeInput from '../dataset_attribute_input';
import DatasetAttributeComponent from '../dataset_attribute';

export default class CombinedAttribute extends DatasetAttributeComponent {
    aggregationInput = null;

    canRemove() {
        return this.props.attribute.column;
    }

    renderAttribute() {
        const {attribute} = this.props;
        return (
            <>
                {!!attribute.column && (
                    <DatasetAttributeInput
                        attribute={attribute}
                        propName="aggregation"
                        valueProp="label"
                        placeholder="total"
                        menu={MENUS.COMBINED_AGG}
                        ref={(el) => { this.aggregationInput = el; }}
                    />
                )}
                <DatasetAttributeInput
                    attribute={attribute}
                    propName="column"
                    valueProp="fullName"
                    placeholder="+ Add Column"
                    focusedPlaceholder="Search for column name"
                    menu={MENUS.COLUMN}
                    ref={(el) => { this.columnInput = el; }}
                />
            </>
        )
    }
}
